import { IFilterSettingsModel } from 'tno-core';

export const defaultFilter: Partial<IFilterSettingsModel> = {
  contentTypes: [],
  sourceIds: [],
  mediaTypeIds: [],
};
